<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="search"
          :headers="headerQuest"
          :items="estoque"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">Estoque atualizado em: {{dateUpdate}} às {{hourUpdate}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Procurar"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum item encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{search}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#60b5b1" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      isLoading: false,
      fullPage: true,
      search:'',
      headerQuest: [],
      estoque: [],
      dateUpdate: '',
      hourUpdate: ''
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
          return this.editedIndex === -1 ? 'ADICIONAR NOVO USUÁRIO' : 'EDITAR USUÁRIO'
        }
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
    },

    mounted() {
      this.carregaDados()

    },

    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      carregaDados () {
        this.isLoading = true
        let url = ''
        if (sessionStorage.getItem('userPermission') == 'ADMIN' || sessionStorage.getItem('userPermission') == 'SUPERVISOR') {
          url = baseApiUrl + 'Estoques?access_token=' + sessionStorage.getItem('accToken')
        } else {
          url = baseApiUrl + 'Estoques?filter={"where":{"codForn":{"inq":' + sessionStorage.getItem('codFornecedor') + '}}}&access_token=' + sessionStorage.getItem('accToken')
        }
        axios.get(url)
        .then(response => {
          this.isLoading = false
          this.estoque = response.data
          this.dateUpdate = this.formatDate(response.data[0].created.substr(0, 10))
          this.hourUpdate = response.data[0].created.substr(11, 5)
          Object.keys(this.estoque[0]).forEach(header => {
            if(header != 'created' && header != 'id'){
            this.headerQuest.push({
              text: header.toUpperCase(),
              value: header
            })
            }
          });

        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#FEC8C8","Erro ao realizar operação","#BF4554")
        })
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }

  span.v-stepper__step__step.primary {
    background-color: #009B99 !important;
    border-color: #009b9b !important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>
